// Folder status -> badge label + colors (mirrors the folder list / history statuses).
// Shared by the desktop sidebar (VaultSidebar) and the mobile step sheet so both show
// the same status pill next to the folio.
const FOLDER_STATUS_BADGE: Record<string, { label: string; className: string }> = {
  in_progress: { label: "En proceso", className: "bg-amber-100 text-amber-700" },
  in_review: { label: "En revisión", className: "bg-blue-100 text-blue-700" },
  completed: { label: "Completado", className: "bg-emerald-100 text-emerald-700" },
};

export function FolderStatusBadge({ status }: { status?: string }) {
  const badge = status ? FOLDER_STATUS_BADGE[status] : undefined;
  if (!badge) return null;

  return (
    <span
      className={`px-2 py-0.5 rounded-full text-xs font-semibold whitespace-nowrap ${badge.className}`}
    >
      {badge.label}
    </span>
  );
}
